<template>
    <div class="btn-group" role="group">
        <BaseButton
            :label="label"
            v-bind="$attrs"
            class="dropdown-toggle" 
            :size="size"
            data-bs-toggle="dropdown" 
            aria-expanded="false"
            :loading="loading"
            :prefix-icon="prefixIcon"
            :suffix-icon="prefixIcon ? false : true"
            :bold="bold"
            :medium="medium"
            :icon-name="prefixIcon ? iconName : 'arrow-double'"
            :icon-fill="iconFill"
            :icon-width="iconWidth"
            :type="type"
            :is-content="isContent"
            :full-width="fullWidth"
            :variant="variant"
            :variant-style="variantStyle"
            data-bs-auto-close="true" 
        >
            <template #content>
                <slot />
            </template>
        </BaseButton>
        <List :id="`${id}List`" :class="[!shadow ? 'no-shadow' : '']">
            <slot name="dropdown-content" />
        </List>
    </div>
</template>

<script>
import List from "../lists/List.vue";
import BaseButton from "./BaseButton.vue";

export default {
    name: "DropdownButton",

    components: {
        BaseButton,
        List,
    },

    props: {
        loading: { type: Boolean, default: false },
        prefixIcon: { type: Boolean, default: false },
        suffixIcon: { type: Boolean, default: false },
        isContent: { type: Boolean, default: false },
        bold: { type: Boolean, default: false },
        medium: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        iconName: { type: String, default: "" },
        iconFill: { type: String, default: "inherit" },
        iconWidth: { type: String, default: "16px" },
        type: { type: String, default: "button"},
        id: { type: String, default: "", required: true },
        fullWidth: { type: Boolean, default: false },
        shadow: { type: Boolean, default: true },
        label: {
            type: String,
            default: "",
        },
        variant: { 
            type: String, 
            default: "default",
            validator: (value) => {
                return ["default", "secondary", "outline", "ghost", "warning"].includes(value);
            },
        },
        variantStyle: { 
            type: String, 
            default: "secondary",
            validator: (value) => {
                return ["", "primary", "secondary", "warning"].includes(value);
            },
        },
        size: { 
            type: String, 
            default: "md",
            validator: (value) => {
                return ["xs", "sm", "md", "lg"].includes(value);
            },
        },
    },
};
</script>